export enum NoteType {
    Prospect = 'prospect',
    Calls = 'calls',
    Action = 'action',
}

export enum IsDeleted {
    No = 0,
    Yes = 1,
}

export interface Notes {
    id?: string;
    type: NoteType;
    recordId: string;
    createdAt?: string;
    createdBy?: string | any;
    content: string;
    deleted?: IsDeleted;
    files?: any;
}
